<template lang="pug">
    .writebacks-submenu
        writeback-filters
        company-filters
</template>

<script>
import WritebackFilters from "./WritebackFilters";

export default {
	components: {
		WritebackFilters
	}
};
</script>
